import React from 'react'
import { useTranslation } from 'react-i18next'
import { Badge, BadgeColor } from '@pandiafi/design-system'

import { UserMetadata } from '../../../../../common/validations'

interface ContractLabelProps {
  label: string
  userMetadata?: UserMetadata
}

export const ContractLabel: React.FC<ContractLabelProps> = ({
  label,
  userMetadata,
}) => {
  const { t } = useTranslation('frontPage')

  return (
    <div className="flex gap-5 flex-wrap phone:flex-col-reverse phone:gap-1">
      {userMetadata?.isImpersonator && (
        <Badge color={BadgeColor.PRIMARY}>
          <span className="text-common-gray-7">
            {t('impersonate.text', {
              impersonator: userMetadata?.impersonatorEmail,
            })}
          </span>
        </Badge>
      )}
      <span className="text-emphasis flex flex-col gap-2 items-center">
        {label}
      </span>
    </div>
  )
}
